import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/services";
import Reveal from "@/components/Reveal";
import PartnersMarquee from "@/components/PartnersMarquee";

const Services = () => {
  return (
    <>
      <section className="pt-[160px] pb-20 max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
        <div className="font-mono text-[11px] tracking-overline uppercase text-accent mb-6">
          [ Services ]
        </div>
        <h1 className="font-display font-bold text-[3rem] md:text-[5rem] leading-[0.98] tracking-tightest max-w-4xl">
          Six disciplines.{" "}
          <span className="text-brand">One clean-air partner.</span>
        </h1>
        <p className="mt-8 text-[18px] text-muted-foreground max-w-2xl leading-relaxed">
          Calmbreeze covers the full mechanical envelope of your building — from filters and fans
          to fire dampers and refrigerant compliance. Every service is documented, certified and
          delivered around your operational hours.
        </p>
      </section>

      <section className="pb-24 max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal
              key={s.slug}
              delay={i * 60}
              className=""
            >
              <Link
                to={`/services/${s.slug}`}
                data-testid={`services-list-${s.slug}`}
                className="group block bg-white border border-black/8 rounded-md overflow-hidden hover:border-black/20 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                  />
                </div>
                <div className="p-8 md:p-10">
                  <div className="flex items-start justify-between gap-4 mb-6">
                    <div className="font-mono text-[11px] tracking-overline uppercase text-muted">
                      {s.overline} · Service
                    </div>
                    <ArrowUpRight className="h-5 w-5 text-ink/40 group-hover:text-brand transition-colors" />
                  </div>
                  <h3 className="font-display font-semibold text-[1.6rem] md:text-[1.85rem] leading-tight tracking-tight mb-4 group-hover:text-brand transition-colors">
                    {s.title}
                  </h3>
                  <p className="text-[15px] text-muted-foreground leading-relaxed">{s.short}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <PartnersMarquee heading="Delivering clean air for" />
    </>
  );
};

export default Services;
